import React, { useEffect } from 'react';
import useAppState from '../../AppStore';
import './identifyView.scss';
import NoIdentify from './components/NoIdentify';
import { ToolNames } from '../ToolNames';
import Scrollable from '../../components/scrollable/Scrollable';
import IdentifyGeneralInfo from './components/IdentifyGeneralInfo';
import ToleranceDropdown from './components/ToleranceDropdown';
import IdentifyLayerInfos from './components/IdentifyLayerInfos';

const IdentifyView = () => {
  const identifyCoordinate = useAppState((state) => state.identifyCoordinate);
  const activeFlyin = useAppState((state) => state.activeFlyin);
  const setActiveFlyin = useAppState((state) => state.setActiveFlyin);
  const activeTool = useAppState((state) => state.activeTool);
  const tolerance = useAppState((state) => state.tolerance);
  const setTolerance = useAppState((state) => state.setTolerance);

  // Überprüfe, ob die Koordinaten vorhanden sind
  const hasValidCoordinates =
    identifyCoordinate &&
    identifyCoordinate.length === 2 &&
    identifyCoordinate[0] !== 0 &&
    identifyCoordinate[1] !== 0;

  useEffect(() => {
    if (
      [ToolNames.draw, ToolNames.print].includes(activeTool) &&
      activeFlyin === 'identify'
    ) {
      setActiveFlyin(null);
    }
  }, [activeTool]);

  return (
    <div className="identifytool_wrapper">
      {identifyCoordinate && hasValidCoordinates ? (
        <Scrollable>
          <IdentifyGeneralInfo
            tolerance={tolerance}
            identifyCoordinate={identifyCoordinate || [0, 0]}
          />
          <ToleranceDropdown
            value={tolerance}
            onChange={(e: any) => setTolerance(e.target.value)}
          />
          <IdentifyLayerInfos
            tolerance={tolerance}
            identifyCoordinate={identifyCoordinate || [0, 0]}
          />
        </Scrollable>
      ) : (
        <NoIdentify />
      )}
    </div>
  );
};

export default IdentifyView;
